import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/document.svg'


const _hoisted_1 = { class: "password-view container" }
const _hoisted_2 = { class: "breadcrumb-password-view py-3 row" }
const _hoisted_3 = { class: "content-password-view" }
const _hoisted_4 = { class: "d-flex flex-row row" }
const _hoisted_5 = { class: "col-12 col-md-6" }
const _hoisted_6 = { class: "input-create-user" }
const _hoisted_7 = { class: "input-create-password col-12" }
const _hoisted_8 = { class: "d-flex justify-content-end mt-2 row" }
const _hoisted_9 = { class: "col-xs-12 col-lg-4" }
const _hoisted_10 = ["disabled"]
const _hoisted_11 = { class: "d-flex flex-row justify-content-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Breadcrumb = _resolveComponent("Breadcrumb")!
  const _component_Input = _resolveComponent("Input")!
  const _component_Icon = _resolveComponent("Icon")!
  const _component_Contact = _resolveComponent("Contact")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_Breadcrumb, { pathList: { "Envio de documentos": "#" } })
    ]),
    _cache[6] || (_cache[6] = _createElementVNode("div", { class: "title-upload-login-view text-start" }, [
      _createElementVNode("h2", { class: "fw-600" }, "Envio de documentos")
    ], -1)),
    _cache[7] || (_cache[7] = _createElementVNode("div", { class: "description-password-view text-start" }, [
      _createElementVNode("p", null, "Por aqui você pode enviar os documentos que ficaram pendentes para a finalização da sua emissão.")
    ], -1)),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _cache[5] || (_cache[5] = _createElementVNode("div", { class: "col-12 col-md-6 d-none d-md-block text-center" }, [
          _createElementVNode("img", {
            alt: "emitir-certificado",
            src: _imports_0
          })
        ], -1)),
        _createElementVNode("div", _hoisted_5, [
          _cache[4] || (_cache[4] = _createElementVNode("div", { class: "description-password-view d-flex text-start" }, [
            _createElementVNode("div", { class: "text" }, [
              _createTextVNode("Tenha em mãos o "),
              _createElementVNode("strong", null, "código da solicitação"),
              _createTextVNode(" que você recebeu por e-mail e a sua "),
              _createElementVNode("strong", null, "senha de emissão"),
              _createTextVNode(".")
            ])
          ], -1)),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_Input, {
              class: "mb-5",
              label: "Código da solicitação",
              icon: "lock",
              "is-required": true,
              modelValue: _ctx.model.codigoSolicitacao,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.model.codigoSolicitacao) = $event)),
              placeholder: "Ex: 11DE2302076A8XXX",
              type: "text",
              tooltipTitle: _ctx.requestCodeTooltipText
            }, null, 8, ["modelValue", "tooltipTitle"])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_Input, {
              class: "mb-5",
              label: "Senha de emissão",
              icon: "lock",
              "is-required": true,
              placeholder: "Digite a senha de emissão",
              type: "password",
              modelValue: _ctx.model.password,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.model.password) = $event)),
              errorLog: _ctx.error
            }, null, 8, ["modelValue", "errorLog"]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("button", {
                  class: _normalizeClass(["btn w-100 d-flex justify-content-center align-items-center", !_ctx.isValid ? "btn-secondary" : "btn-primary"]),
                  type: "button",
                  disabled: !_ctx.isValid,
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)))
                }, [
                  _createElementVNode("div", _hoisted_11, [
                    _cache[3] || (_cache[3] = _createElementVNode("span", null, "Avançar", -1)),
                    _createVNode(_component_Icon, {
                      class: "ms-2",
                      name: "arrow-right"
                    })
                  ])
                ], 10, _hoisted_10)
              ])
            ])
          ])
        ])
      ]),
      _createVNode(_component_Contact)
    ])
  ]))
}